// import {
//   BasicLayout,
// } from '@/layouts'
// 前端路由表
const constantRouterComponents = {

  PageView: () => import('../components/PageView.vue'),
  PC_Index: () => import('../views/PC/index.vue'),
  PC_home: () => import('../views/PC/home.vue'),
  PC_User: () => import('../views/PC/User/index.vue'),
  PC_Permission: () => import('../views/PC/Permission/index.vue'),
  PC_Customer: () => import('../views/PC/Customer/index.vue'),
  PC_SalesLead: () => import('../views/PC/SalesLead/index.vue'),
  PC_Project: () => import('../views/PC/Project/index.vue'),
  PC_Contract: () => import('../views/PC/Contract/index.vue'),
  PC_Contact: () => import('../views/PC/Contact/index.vue'),
  PC_UnPaidProject: () => import('../views/PC/StatisticRecord/UnPaidProject.vue'),
  PC_Part: () => import('../views/PC/Part/index.vue'),
  PC_Store: () => import('../views/PC/Store/index.vue'),

  M_Index: () => import('../views/Mobile/index.vue'),
  M_home: () => import('../views/Mobile/home.vue'),
  M_UnPaidProject: () => import('../views/Mobile/StatisticRecord/UnPaidProject.vue'),
  M_ProjectDetail: () => import('../views/Mobile/StatisticRecord/ProjectDetail.vue'),
  PC_Task: () => import('../views/PC/Task/index.vue'),
  PC_Add_Task: () => import('../views/PC/Task/AddTask.vue'),
  PC_Pick: () => import('../views/PC/PartPicking/index.vue'),
  PC_PrintPickForm: () => import('../views/PC/PartPicking/printPickingForm.vue'),
  PC_PartInRecord: () => import('../views/PC/HistoryQuery/partInRecord.vue'),
  PC_PartOutRecord: () => import('../views/PC/HistoryQuery/partOutRecord.vue'),
  PC_InvoiceRecord: () => import('../views/PC/HistoryQuery/invoiceRecord.vue'),
  PC_CollectionRecord: () => import('../views/PC/HistoryQuery/collectionRecord.vue'),
  PC_RealInventory: () => import('../views/PC/HistoryQuery/realInventory.vue'),
  PC_HisContractRecord: () => import('../views/PC/HistoryQuery/contractRecord.vue'),
  PC_HisStockCheckRecord: () => import('../views/PC/HistoryQuery/stockCheckRecord.vue'),
  PC_SystemSetting: () => import('../views/PC/SystemSetting/processFlow.vue'),
  PC_Quote: () => import('../views/PC/Quotes/index.vue'),
  PC_PR_index: () => import('../views/PC/Purchase/purchaseRequest.vue'),
  PC_PO_index: () => import('../views/PC/Purchase/purchaseOrder.vue'),
  PC_Supplier: () => import('../views/PC/Supplier/index.vue'),
  PC_Department_index: () => import('../views/PC/HR/department.vue'),
  PC_Job_index: () => import('../views/PC/HR/job.vue'),
  PC_Employee_index: () => import('../views/PC/HR/employee.vue'),
  PC_LaborContract_index: () => import('../views/PC/HR/laborContract.vue'),
  PC_ExpenseReport_index: () => import('../views/PC/HR/expenseReport.vue'),
  PC_LoginRecord: () => import('../views/PC/LogQuery/loginRecord.vue'),
  PC_TaskConfig: () => import('../views/PC/SystemSetting/task.vue')
}

// 前端未找到页面路由（固定不用改）
const notFoundRouter = {
  path: '*',
  redirect: '/404',
  hidden: true
}
// 根级菜单
const rootRouter_P = {
  path: '/',
  key: 'PC_Index',
  redirect: '/pc_home',
  name: 'PC_Index'
}
// 根级菜单
const rootRouter_M = {
  path: '/',
  key: 'M_Index',
  redirect: '/m_home',
  name: 'M_Index',
}
const type = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? 2 : 1
/**
 * 动态生成菜单
 * @param token
 * @returns {Promise<Router>}
 */
export const generatorDynamicRouter = () => {
  return new Promise((resolve, reject) => {
    let result = JSON.parse(sessionStorage.getItem('Actions'))
    let Enumerable = require('linq').default
    let list = result.filter(it => {
      return it
    })
    let groupResult = Enumerable.from(list).distinct("x=>x.ActionID").toArray();
    const menuNav = [
    ]
    const childrenNav = []
    //      后端数据, 根级树数组,  根级 PID
    listToTree(groupResult, childrenNav, 0)
    // if (type === 1) {
    rootRouter_P.children = childrenNav
    menuNav.push(rootRouter_P)
    console.log(rootRouter_P, "rootRouter_P")
    // }
    // if (type === 2) {
    //   rootRouter_M.children = childrenNav
    //   // rootRouter_M.children.push({
    //   //   Component: constantRouterComponents['M_ProjectDetail'],
    //   //   Title: "项目详情",
    //   //   key: "m_ProjectDetail",
    //   //   name: "m_ProjectDetail",
    //   //   path: "/m_ProjectDetail",
    //   // })
    //   menuNav.push(rootRouter_M)
    // }

    const routers = generator(menuNav)
    routers.push(notFoundRouter)

    if (routers[0] && routers[0].children) {
      routers[0].children.sort((a, b) => {
        return a.Sequence - b.Sequence
      })
    }
    // const cc = FilerList(routers)
    resolve(routers)
  })
}
export const FilerList = (routers, parent) => {

  // Enumerable.From(myList).Distinct("x=>x.Age").ToArray();
  // linqs = routers
}
/**
 * 格式化树形结构数据 生成 vue-router 层级路由表
 *
 * @param routerMap
 * @param parent
 * @returns {*}
 */
export const generator = (routerMap, parent) => {
  return routerMap.map(item => {
    // let Enumerable = require('linq')
    const {
      title,
      show,
      hideChildren,
      hiddenHeaderContent,
      target,
      icon
    } = item.meta || {}
    const currentRouter = {
      // 如果路由设置了 path，则作为默认 path，否则 路由地址 动态拼接生成如 /dashboard/workplace
      path: item.path || `${parent && parent.path || ''}/${item.key}`,
      // 路由名称，建议唯一
      name: item.name ? item.name : null,
      redirect: item.Redirect,
      //  该路由对应页面的 组件 :方案1
      //component: (constantRouterComponents[item.key]) || (() => import(`${item.component}`)),
      component: constantRouterComponents[item.key],
      // () => import(item.Component),
      //constantRouterComponents[item.key || item.Component],
      Sequence: item.Sequence,
      // 该路由对应页面的 组件 :方案2 (动态加载)
      // component: (constantRouterComponents[item.key]) || (() => import(`@/views/${item.component}`)),
      // component: item.Component,

      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: {
        title: item.Title || '首页',
        keepAlive: true,
        icon: item.Icon || undefined,
        hiddenHeaderContent: hiddenHeaderContent,
        target: target,
        // permission: item.name
      },
      show: item.Show === false ? false : true

    }
    // 是否设置了隐藏菜单
    if (currentRouter && currentRouter.show === false) {
      currentRouter.hidden = true
    }
    // 是否设置了隐藏子菜单
    if (hideChildren) {
      currentRouter.hideChildrenInMenu = true
    }
    // 为了防止出现后端返回结果不规范，处理有可能出现拼接出两个 反斜杠
    if (!currentRouter.path.startsWith('http')) {
      currentRouter.path = currentRouter.path.replace('//', '/')
    }

    // 重定向
    item.redirect && (currentRouter.redirect = item.redirect)
    // 是否有子菜单，并递归处理
    if (item.children && item.children.length > 0) {
      // Recursion
      currentRouter.children = generator(item.children, currentRouter)
    }
    return currentRouter
  })
}
/**
 * 数组转树形结构
 * @param list 源数组
 * @param tree 树
 * @param parentId 父ID
 */
const listToTree = (list, tree, parentId) => {
  if (list && list.length > 0) {
    list.forEach(item => {
      // 判断是否为父级菜单
      if (item.ParentID === parentId) {
        const child = {
          ...item,
          key: item.key || item.name,
          children: []
        }
        // 迭代 list， 找到当前菜单相符合的所有子菜单
        listToTree(list, child.children, item.ActionID)
        // 删掉不存在 children 值的属性
        if (child.children.length <= 0) {
          delete child.children
        }
        // 加入到树中
        tree.push(child)
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/router/generator-routers.js